import axiosConfig from "../axiosConfig";

/**
 * S3 Service - Handles all S3 related operations
 */

/**
 * Generate a presigned URL for uploading a file to S3
 * @param fileName - The name of the file to upload
 * @returns Presigned URL for uploading
 */
export const getS3PresignedUrl = async (fileName: string): Promise<string> => {
  const res = await axiosConfig.post("/image/generate-s3-presigned-url", {
    file_name: fileName,
  });

  if (res.status === 200) {
    return res.data.body.url;
  } else {
    throw new Error("Failed to get presigned URL");
  }
};

/**
 * Get a presigned URL for accessing/downloading an object from S3
 * @param objectKey - The S3 object key (file name in S3)
 * @returns Presigned URL for accessing the object
 */
export const getS3ObjectPresignedUrl = async (
  objectKey: string
): Promise<string> => {
  const res = await axiosConfig.post("/image/get-s3-object-presigned-url", {
    file_name: objectKey,
  });

  if (res.status === 200) {
    return res.data.body.url;
  } else {
    throw new Error("Get S3 object presigned URL failed");
  }
};

/**
 * Upload a file to S3 using a presigned URL
 * @param file - The file to upload
 * @param presignedUrl - The presigned URL for uploading
 */
export const uploadFileToS3 = async (
  file: File,
  presignedUrl: string
): Promise<void> => {
  try {
    await fetch(presignedUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": "application/octet-stream",
      },
    });
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};
